import * as yup from "yup";

export const monitoringCgsDeadlineApprove: yup.ObjectSchema<any> = yup.object().shape({
  unfulfilled_used_amount_month_day: yup.number().required("გთხოვთ, მიუთითოთ ახალი ვადის თვე/დღე.").min(1, "გთხოვთ, მიუთითოთ ახალი ვადის თვე/დღე."),
});
